import type { ReactNode } from "react"
import { X } from "lucide-react"

import { Button } from "@/components/ui/button"

type RequestSideDrawerProps = {
  open: boolean
  title: string
  onClose: () => void
  children: ReactNode
  footer?: ReactNode
}

/**
 * Right-side drawer used by TopUp / Request Account forms.
 * Pattern mirrors FormPage campaign queue aside.
 */
export function RequestSideDrawer({
  open,
  title,
  onClose,
  children,
  footer,
}: RequestSideDrawerProps) {
  if (!open) return null

  return (
    <>
      <button
        type="button"
        aria-label="Close drawer"
        className="fixed inset-0 z-40 bg-black/45"
        onClick={onClose}
      />
      <aside className="fixed right-0 top-0 z-50 flex h-screen w-full max-w-[540px] flex-col border-l border-[#454545] bg-[#262626] shadow-[-10px_0_30px_rgba(0,0,0,0.45)]">
        <div className="flex items-center justify-between border-b border-[#454545] px-5 py-4">
          <h2 className="text-lg font-semibold text-white">{title}</h2>
          <Button
            type="button"
            variant="ghost"
            size="sm"
            onClick={onClose}
            className="h-8 w-8 p-0 text-white hover:bg-[#323232] hover:text-white"
            aria-label="Close"
          >
            <X className="h-4 w-4" />
          </Button>
        </div>
        <div className="min-h-0 flex-1 overflow-y-auto px-5 py-4">{children}</div>
        {footer ? (
          <div className="border-t border-[#454545] px-5 py-4">{footer}</div>
        ) : null}
      </aside>
    </>
  )
}
